import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Log',
    entityNamePlural: 'SCA Promotions',
    entityNameModule: 'cms',
    basePath: `/cms/sweep/contests`,
    defaultParams: {
      drawType: 'sca',
    },
  }), [])
}
